import React, { createContext, useCallback, useContext, useState } from "react";

import BaseBanner from "@/components_v2/Banner/BaseBanner";
import { BaseBannerProps } from "@/components_v2/Banner/types";

interface PageBannerContextValue {
  bannerContent: BaseBannerProps | null;
  setBannerContent: (content: BaseBannerProps | null) => void;
  clearBanner: () => void;
}

const PageBannerContext = createContext<PageBannerContextValue | null>(null);

export const PageBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [bannerContent, setBannerContent] = useState<BaseBannerProps | null>(
    null,
  );

  const clearBanner = useCallback(() => {
    setBannerContent(null);
  }, []);

  const value: PageBannerContextValue = {
    bannerContent,
    setBannerContent,
    clearBanner,
  };

  return (
    <PageBannerContext.Provider value={value}>
      {children}
    </PageBannerContext.Provider>
  );
};

export const usePageBanner = (): PageBannerContextValue => {
  const context = useContext(PageBannerContext);
  if (!context) {
    throw new Error("usePageBanner must be used within a PageBannerProvider");
  }
  return context;
};

export const PageBannerSlot = () => {
  const { bannerContent } = usePageBanner();
  if (!bannerContent) return null;
  return (
    <div className="full-width">
      <BaseBanner {...bannerContent} />
    </div>
  );
};
